import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { MailEntity } from '@source/mails/entities/mail.js';
import type { ContactEntity } from './contact.js';
import type { IntercomEntity } from './intercom.js';

export enum ProcessType {
  TAG_CRON = 'TAG_CRON',
  TAG_TEST = 'TAG_TEST',
  PRIORITY = 'PRIORITY',
  CONTACT_CRON = 'CONTACT_CRON',
  CONTACT_TEST = 'CONTACT_TEST',
  PROCESS_EMAIL = 'PROCESS_EMAIL',
  INTERCOM = 'INTERCOM',
}

registerEnum({ enum: ProcessType, name: 'ProcessType' });

export enum ProcessStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
registerEnum({ enum: ProcessStatus, name: 'ProcessStatus' });

@Entity()
export class ProcessEntity extends MongoEntity {
  static override _class = 'ProcessEntity';
  static override _collectionName = 'processes';
  @Field(() => Date) timestamp: Maybe<Date>;
  @Field(() => Date) timestampEnd: Maybe<Date>;
  @Field(() => ProcessType) processType: Maybe<ProcessType>;
  @Field(() => ProcessStatus) processStatus: Maybe<ProcessStatus>;
  @Field(() => MongoEntity) referencedEntity: Maybe<IntercomEntity | MailEntity | ContactEntity>;
  @Field(() => [String]) logs: Maybe<string[]>;
  @Field(() => [String]) errors: Maybe<string[]>;

  static override async beforeCreate(entity: ProcessEntity) {
    await super.beforeCreate(entity);
    entity.timestamp = new Date();
  }
}
